module.exports = __webpack_public_path__ + "static/media/Parkland2021.842e13d3.png";